import { render, staticRenderFns } from "./QRCardComponent.vue?vue&type=template&id=698512a6&"
import script from "./QRCardComponent.vue?vue&type=script&lang=js&"
export * from "./QRCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports